import { Box, Typography } from "@mui/material";

export const ScoreDisplay = ({ score, total }: any) => {
    return (
        <Box
            sx={{
                maxwWidth: 90,
                minWidth: 60,
                maxHeight: 90,
                minHeight: 40,
                borderRadius: "50%",
                border: "2px solid black",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                color: "black",
                textAlign: "center",
                backgroundColor: "white",
                fontFamily: "'Patrick Hand', cursive",
                fontSize: "1.5rem",
                fontWeight: "bold",
                transform: "rotate(-3deg)",
                
                    
            }}
        >
            <Typography
                sx={{
                    position: "absolute",
                    top: "25%",
                    transform: "translateY(-50%) rotate(-5deg)",
                }}
            >
                {Math.round(score)}
            </Typography>

            <Box
                sx={{
                    width: "80%",
                    height: "3px",
                    backgroundColor: "black",
                    position: "absolute",
                    top: "50%",
                    transform: "rotate(-3deg)",
                    borderRadius: "50%",
                }}
            />            
            <Typography
                sx={{
                    position: "absolute",
                    bottom: "20%",
                    transform: "translateY(50%) rotate(5deg)",
                }}
            >
                {Math.round(total)}
            </Typography>
        </Box>
    );
};
